import { render } from "./Toast.vue?vue&type=template&id=f0830954"
import script from "./Toast.vue?vue&type=script&lang=ts"
export * from "./Toast.vue?vue&type=script&lang=ts"
script.render = render

export default script